import { render_maps } from "./render-maps";
import { render_candidates } from "./render-candidates";

export const render_searchBar = () => {
  const container = d3
    .select("#candidate-search #autocomplete .container")
    .append("form");
  container.append("label").text("Enter a Chicago address");

  let addrNum = "";
  let addresses = [];

  const update = (e, addresses) => {
    // results.selectAll("button").remove();
    // results.selectAll("span").remove();
    results.html(null);
    if (!addresses.length) {
      results
        .append("span")
        .attr("class", "no-results")
        .text(`No results for ${e.target.value}`);
      return;
    }
    addresses
      .filter((d, i) => i < 4)
      .map((d) => {
        results
          .append("button")
          .attr("class", "results-btn")
          .text(d.label)
          .on("click", () => {
            e.target.value = d.label;
            sel.ward = d.ward;
            sel.precinct = d.precinct;
            d3.select(".you-are-here").text(
              `You are in Ward ${sel.ward} and Police District ${sel.precinct}.`
            );
            window.dataLayer.push({
              event: "e_AddressSelect",
              dl_wardSelected: sel.ward,
              dl_policeDistrict: sel.precinct,
            });
            render_maps();
            render_candidates();
            results.html(null);
          });
      });
  };

  const searchBar = container.append("div").attr("class", "search-container");
  searchBar.append("input").attr("placeholder", "121 N LaSalle St");
  searchBar
    .append("button")
    .attr("class", "clr-btn")
    .text("X")
    .attr("type", "button")
    .on("click", () => {
      searchBar.select("input").node().value = "";
      addrNum = "";
      addresses = [];
      // results.selectAll("button").remove();
      // results.select(".no-results").remove();
      results.html(null);
      sel.ward = null;
      sel.precinct = null;
      render_maps();
      d3.select(".you-are-here").text(null);
      render_candidates();
    });
  const results = d3
    .select("#candidate-search #autocomplete .container")
    .append("div")
    .attr("class", "results");

  d3.select("#candidate-search #autocomplete .container")
    .append("div")
    .attr("class", "you-are-here")
    .text(null);

  searchBar.on("input", (e) => {
    d3.select("option.ward-default").property("selected", true);
    d3.select("option.precinct-default").property("selected", true);

    const text = e.target.value;
    if (!text.length) {
      // results.selectAll("button").remove();
      results.html(null);
      return;
    }
    // replace non alpha and trailing directionals
    const inputAddr = text.split(" ")[0].replace(/[^0-9]/g, "");
    const matchAddr = text
      .replace(/[^a-z0-9 ]/gim, "")
      .toUpperCase()
      .replace(/\s+/g, " ")
      .replace(/(\d+ [nsew])([a-z]+)(.*)/gi, "$1$3")
      .trim();

    if (addrNum === inputAddr && addresses.length > 0) {
      update(
        e,
        addresses.filter((addr) => addr.label.startsWith(matchAddr)).slice(0, 5)
      );
    } else {
      addrNum = inputAddr;
      return fetch(
        `https://ward-lookup-data.s3.us-east-2.amazonaws.com/addressLookup/${addrNum}.json`
      )
        .then((res) => res.json())
        .then((res) => {
          addresses = Object.keys(res).map((addr) => ({
            ward: +res[addr].w,
            precinct: +res[addr].pd,
            label: addr,
          }));
          return addresses
            .filter((addr) => addr.label.startsWith(matchAddr))
            .slice(0, 5);
        })
        .then(() => {
          update(e, addresses);
        })
        .catch((res) => console.error(res));
    }
  });
  container.on("submit", (e) => {
    e.preventDefault();

    // e.target.value = d.label;
    const text = searchBar
      .select("input")
      .node()
      .value.replace(/[^a-z0-9 ]/gim, "")
      .toUpperCase()
      .replace(/\s+/g, " ")
      .replace(/(\d+ [nsew])([a-z]+)(.*)/gi, "$1$3")
      .trim();
    const match = addresses.filter((d) => d.label === text)[0];
    if (match) {
      sel.ward = match.ward;
      sel.precinct = match.precinct;
      d3.select(".you-are-here").text(
        `You are in Ward ${sel.ward} and Police District ${sel.precinct}.`
      );
      render_maps();
      render_candidates();
      // results.selectAll("button").remove();
    } else {
      d3.select(".you-are-here").text(
        `No Ward or Police District found for ${text}.`
      );
    }
    results.html(null);
  });
};

render_searchBar();
